export default __webpack_public_path__ + "static/social-tariff-89fff4f81420a2497786bc85500a515f.webp";